<template>
  <div class="Footer">
    <div class="container">
      <div class="FooterContent">
        <div class="FooterLogo">
          <a href="/"><img src="../assets/img/logo_dark.svg" alt="logo"/></a>
        </div>
        <div class="FooterMenu">
          <router-link class="FooterLink" to="/terms">Terms of use</router-link>
          <router-link class="FooterLink" to="/privacy"
            >Privacy policy</router-link
          >
          <router-link class="FooterLink" to="/pricing">Pricing</router-link>
          <p class="FooterLink copyright" to="/#">
            &copy; 2020 DevStack
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
.Footer {
  background-color: $color-white;
}
.FooterContent {
  display: flex;
  justify-content: space-between;
  padding: 40px 0;
}
.FooterLogo {
  img {
    width: 135px;
  }
}
.FooterMenu {
  display: flex;
  align-items: center;
  .FooterLink {
    margin-right: 30px;
    font-weight: 400;
    font-size: 14px;
    text-decoration: none;
    color: $color-grey;
    &:hover {
      color: $color-black;
    }
  }

  .copyright {
    display: inline;
    margin-right: 0;
  }
}

@media screen and (max-width: 650px) {
  .FooterContent {
    flex-direction: column;
    .FooterLogo {
      margin-bottom: 20px;
    }
    .FooterMenu {
      display: flex;
      flex-wrap: wrap;
      .FooterLink {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
